<div class="content space-y-4">

    <div class="flex justify-between items-center">
        <div class="flex items-center gap-2 text-lg font-semibold text-primary-500">
            <fa-icon [icon]="faMagnifyingGlassChart" class="text-primary-500 text-xl"></fa-icon>
            <span>การวิเคราะห์ข้อมูลเชิงลึก</span>
        </div>
    </div>

    <div class="w-full text-base font-medium text-center text-gray-500 border-b border-gray-200">
        <div class="w-full md:w-fit flex flex-wrap -mb-px">
            <button class="flex-1 me-2" (click)="state='sale'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='sale' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='sale'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    ยอดขาย</p>
            </button>
            <button class="flex-1 me-2" (click)="state='product-overview'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='product-overview' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='product-overview'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    Top สินค้าขายดี</p>
            </button>
            <button class="flex-1 me-2" (click)="state='product'">
                <p [ngClass]="{'text-black font-semibold border-primary-500':state==='product' , 'border-transparent hover:text-gray-600 hover:border-gray-300':state!=='product'}"
                    class="inline-block whitespace-nowrap p-4 border-b-2 rounded-t-lg">
                    สินค้า</p>
            </button>
        </div>
    </div>

    @if(state==='sale'){
    <app-purchase-analysis-sale></app-purchase-analysis-sale>
    }
    @if(state==='product-overview'){
    <app-purchase-analysis-product-overview></app-purchase-analysis-product-overview>
    }
    @if(state==='product'){
    <app-purchase-analysis-product></app-purchase-analysis-product>
    }

</div>